import { render } from "./z-btn.vue?vue&type=template&id=3926ff74&scoped=true&lang=pug"
import script from "./z-btn.vue?vue&type=script&setup=true&lang=js"
export * from "./z-btn.vue?vue&type=script&setup=true&lang=js"

import "./z-btn.vue?vue&type=style&index=0&id=3926ff74&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3926ff74"]])

export default __exports__